import { FC, ReactNode } from 'react';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export type Path = {
  link?: string;
  name: ReactNode;
};

type Props = {
  breadcrumbs: Path[];
};

export type BreadcrumbsProps = Props;

const Breadcrumbs: FC<Props> = ({ breadcrumbs }) => {
  return (
    <MuiBreadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      sx={{ mb: 1 }}>
      <Link underline="hover" color="inherit" href="/">
        Tedo.lt
      </Link>

      {breadcrumbs.map(({ link, name }, i) => {
        return link ? (
          <Link key={i} underline="hover" color="inherit" href={link}>
            {name}
          </Link>
        ) : (
          <Typography key={i} color="text.primary">
            {name}
          </Typography>
        );
      })}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumbs;
